// src/App.tsx
import React from 'react';
import AppRouter from './routes/AppRouter';
import { LoaderProvider } from './context/LoaderContext';
// Importa tus estilos globales si tienes un App.css o index.css

const App: React.FC = () => {
  // El componente principal App.tsx solo necesita renderizar el router.
  // Toda la lógica de navegación (i18n, rutas amigables) está en AppRouter.
  return <LoaderProvider> <AppRouter /> </LoaderProvider>;
};

export default App;
